import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {dataToolSchemas} from '../../utils/schemas';

const toolName = 'list-form-submissions' as const;

const argumentZod = z.object({
  elementId: z
    .string()
    .optional()
    .describe(
      'Filter submissions to a single form by its element GUID. Optional — omit to return submissions for all forms on the site.'
    ),
  localeId: dataToolSchemas.localeId.optional(),
  limit: z
    .number()
    .int()
    .optional()
    .describe(
      'Maximum number of submissions to return (default: 25, max: 100)'
    ),
  offset: z
    .number()
    .int()
    .min(0)
    .optional()
    .describe(
      'Number of submissions to skip for pagination. Use with the returned pagination.total to fetch subsequent pages.'
    ),
});

export const listFormSubmissionsManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'List form submissions',
  family: 'forms',
  llmTool: {
    name: toolName,
    description:
      'Lists form submissions for the current site, sorted by submission date (newest first). Returns submission data including the submitted field values, submission timestamp, and the originating form. Optionally filter to a single form via elementId.',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [{resource: 'SiteForm', action: 'read'}],
  confirmBeforeExecuting: false,
});

export type ListFormSubmissionsArgumentType = z.infer<typeof argumentZod>;
